import { invokeService } from '@alife/tarot';
const initData = {
  list: [],
  isLoading: false,
  bodyLoading: false,
  isEnd: false,
  reqOnlyList: [],
  formParams: {
    beginpage: 1,
    asyncreq: 1,
    keywords: "",
    sortType: "",
    descendOrder: "",
    province: "",
    city: "",
    priceStart: "",
    priceEnd: "",
    dis: "",
    ptid : window.p4pObject && window.p4pObject.ptid || ""
  }
};
const Module = {
  name: 'offer',
  initState: initData,
  reducers: {
    setParams(state, action) {
      return {
        ...state,
        formParams: {
          ...state.formParams,
          ...action.payload
        }
      }
    },
    setReqOnlyList(state, action) {
      return {
        ...state,
        reqOnlyList: action.payload.reqOnlyList
      }
    },
    resetData() {
      return initData;
    },
    resetList(state) {
      return {
        ...state,
        list: []
      }
    }
  },
  effects: {
    * getHomeList(actions, { call }, state) {
      const payload = Object.assign({}, state.formParams, actions.payload);
      if(window.pageConfig && window.pageConfig._hamlet_new_ad_supply_pc_) {
        payload._hamlet_new_ad_supply_pc_ = window.pageConfig._hamlet_new_ad_supply_pc_;
      }
      try {
         yield call(invokeService, 'getOfferUrl', payload);
      } catch (e) {
        throw e;
      }
    },
    * getList(actions, { put, call }, state) {
      const payload = Object.assign({}, state.formParams, actions.payload, {
        exp: window.pageConfig.exp
      });
      if(window.pageConfig && window.pageConfig._hamlet_new_ad_supply_pc_) {
        payload._hamlet_new_ad_supply_pc_ = window.pageConfig._hamlet_new_ad_supply_pc_;
      }
      const preFormparams = state.formParams;
      yield put("offer/setValues", {
        isLoading: true
      });
      try {
        const result = yield call(invokeService, 'getOfferUrl', payload);
        const offerResult = result.body.data.content ? result.body.data.content.offerResult : [];
        //请求
        const preList = state.list;
        const allList = preList.concat(offerResult);
        // 数据更新依然需要交给 reducer
        yield put("offer/setValues", {
          list: allList,
          isLoading: false,
          bodyLoading: false,
          reqOnlyList: offerResult
        });
        if (offerResult.length < 20) {
          yield put("offer/setValues", {
            isEnd: true
          });
        }
        yield put("offer/setParams", {
          asyncreq: preFormparams.asyncreq + 1
        })
        if (window.Light) {
          window.Light.light();
        }
      } catch (e) {
        yield put("offer/setValues", {
          isLoading: false,
          bodyLoading: false
        });
        throw e;
      }
    }
  }
};


export default Module;
